import TopSizeChart from './TopSizeChart'

export default TopSizeChart
